import { render, staticRenderFns } from "./PortfolioComparisonLink.vue?vue&type=template&id=32517ac8&scoped=true&"
import script from "./PortfolioComparisonLink.vue?vue&type=script&lang=js&"
export * from "./PortfolioComparisonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32517ac8",
  null
  
)

export default component.exports